/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetInsightCommentsParams,
  InsightCommentDto,
  InsightCommentRequest,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const getInsightComments = (
  userId: string,
  insightId: number,
  params?: GetInsightCommentsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InsightCommentDto[]>(
    {
      url: `/api/${userId}/insights/${insightId}/comments`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetInsightCommentsQueryKey = (
  userId: string,
  insightId: number,
  params?: GetInsightCommentsParams
) => {
  return [
    `/api/${userId}/insights/${insightId}/comments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetInsightCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInsightComments>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params?: GetInsightCommentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightComments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInsightCommentsQueryKey(userId, insightId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInsightComments>>
  > = ({ signal }) =>
    getInsightComments(userId, insightId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && insightId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInsightComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInsightCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInsightComments>>
>;
export type GetInsightCommentsQueryError = ErrorType<unknown>;

export function useGetInsightComments<
  TData = Awaited<ReturnType<typeof getInsightComments>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params: undefined | GetInsightCommentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightComments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsightComments>>,
          TError,
          Awaited<ReturnType<typeof getInsightComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsightComments<
  TData = Awaited<ReturnType<typeof getInsightComments>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params?: GetInsightCommentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightComments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsightComments>>,
          TError,
          Awaited<ReturnType<typeof getInsightComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsightComments<
  TData = Awaited<ReturnType<typeof getInsightComments>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params?: GetInsightCommentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightComments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetInsightComments<
  TData = Awaited<ReturnType<typeof getInsightComments>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params?: GetInsightCommentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightComments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInsightCommentsQueryOptions(
    userId,
    insightId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_CLIENT_SERVICE, ROLE_FD_PRINCIPAL, ROLE_REPORT_ADMIN**<br /><br />
 */
export const createInsightComment = (
  userId: string,
  insightId: number,
  insightCommentRequest: BodyType<InsightCommentRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InsightCommentDto>(
    {
      url: `/api/${userId}/insights/${insightId}/comments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: insightCommentRequest,
      signal,
    },
    options
  );
};

export const getCreateInsightCommentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInsightComment>>,
    TError,
    {
      userId: string;
      insightId: number;
      data: BodyType<InsightCommentRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInsightComment>>,
  TError,
  { userId: string; insightId: number; data: BodyType<InsightCommentRequest> },
  TContext
> => {
  const mutationKey = ['createInsightComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInsightComment>>,
    { userId: string; insightId: number; data: BodyType<InsightCommentRequest> }
  > = (props) => {
    const { userId, insightId, data } = props ?? {};

    return createInsightComment(userId, insightId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInsightCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInsightComment>>
>;
export type CreateInsightCommentMutationBody = BodyType<InsightCommentRequest>;
export type CreateInsightCommentMutationError = ErrorType<unknown>;

export const useCreateInsightComment = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createInsightComment>>,
      TError,
      {
        userId: string;
        insightId: number;
        data: BodyType<InsightCommentRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createInsightComment>>,
  TError,
  { userId: string; insightId: number; data: BodyType<InsightCommentRequest> },
  TContext
> => {
  return useMutation(
    getCreateInsightCommentMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Any authenticated role**
 */
export const getInsightCommentById = (
  userId: string,
  insightId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InsightCommentDto>(
    {
      url: `/api/${userId}/insights/${insightId}/comments/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetInsightCommentByIdQueryKey = (
  userId: string,
  insightId: number,
  id: number
) => {
  return [`/api/${userId}/insights/${insightId}/comments/${id}`] as const;
};

export const getGetInsightCommentByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getInsightCommentById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightCommentById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInsightCommentByIdQueryKey(userId, insightId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInsightCommentById>>
  > = ({ signal }) =>
    getInsightCommentById(userId, insightId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && insightId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInsightCommentById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInsightCommentByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInsightCommentById>>
>;
export type GetInsightCommentByIdQueryError = ErrorType<unknown>;

export function useGetInsightCommentById<
  TData = Awaited<ReturnType<typeof getInsightCommentById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightCommentById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsightCommentById>>,
          TError,
          Awaited<ReturnType<typeof getInsightCommentById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsightCommentById<
  TData = Awaited<ReturnType<typeof getInsightCommentById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightCommentById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsightCommentById>>,
          TError,
          Awaited<ReturnType<typeof getInsightCommentById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsightCommentById<
  TData = Awaited<ReturnType<typeof getInsightCommentById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightCommentById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetInsightCommentById<
  TData = Awaited<ReturnType<typeof getInsightCommentById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightCommentById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInsightCommentByIdQueryOptions(
    userId,
    insightId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_CLIENT_SERVICE, ROLE_FD_PRINCIPAL, ROLE_REPORT_ADMIN**<br /><br />
 */
export const deleteInsightComment = (
  userId: string,
  insightId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${userId}/insights/${insightId}/comments/${id}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getDeleteInsightCommentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInsightComment>>,
    TError,
    { userId: string; insightId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInsightComment>>,
  TError,
  { userId: string; insightId: number; id: number },
  TContext
> => {
  const mutationKey = ['deleteInsightComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInsightComment>>,
    { userId: string; insightId: number; id: number }
  > = (props) => {
    const { userId, insightId, id } = props ?? {};

    return deleteInsightComment(userId, insightId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInsightCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInsightComment>>
>;

export type DeleteInsightCommentMutationError = ErrorType<unknown>;

export const useDeleteInsightComment = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteInsightComment>>,
      TError,
      { userId: string; insightId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteInsightComment>>,
  TError,
  { userId: string; insightId: number; id: number },
  TContext
> => {
  return useMutation(
    getDeleteInsightCommentMutationOptions(options),
    queryClient
  );
};
